import {
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFilePdf,
  FaFileArchive,
  FaFileVideo,
  FaFileAudio,
  FaFile,
} from 'react-icons/fa';

const OFFICE_EXTENSIONS = ['doc', 'docx', 'odt', 'rtf', 'txt', 'xls', 'xlsx', 'ods', 'csv', 'ppt', 'pptx', 'odp'];
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const PDF_EXTENSIONS = ['pdf'];
const ARCHIVE_EXTENSIONS = ['zip', 'rar', '7z', 'tar', 'gz'];
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'webm'];
const AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg', 'm4a'];

const getExtension = (filename) => {
  if (!filename) return '';
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

export const getAttachmentKind = (filename) => {
  const ext = getExtension(filename);
  if (OFFICE_EXTENSIONS.includes(ext)) return 'office';
  if (IMAGE_EXTENSIONS.includes(ext)) return 'image';
  if (PDF_EXTENSIONS.includes(ext)) return 'pdf';
  return 'unsupported';
};

export const getAttachmentIcon = (filename) => {
  const ext = getExtension(filename);
  if (['doc', 'docx', 'odt', 'rtf', 'txt'].includes(ext)) return FaFileWord;
  if (['xls', 'xlsx', 'ods', 'csv'].includes(ext)) return FaFileExcel;
  if (['ppt', 'pptx', 'odp'].includes(ext)) return FaFilePowerpoint;
  if (ext === 'pdf') return FaFilePdf;
  if (ARCHIVE_EXTENSIONS.includes(ext)) return FaFileArchive;
  if (VIDEO_EXTENSIONS.includes(ext)) return FaFileVideo;
  if (AUDIO_EXTENSIONS.includes(ext)) return FaFileAudio;
  return FaFile;
};

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
